import React, { useCallback, useEffect, useState, useRef } from 'react';
import { StyleSheet } from 'react-native';
import { VStack } from 'native-base';
import { createIconSetFromFontello } from 'react-native-vector-icons';
import CalendarAddBlock from './CalendarAddBlock';
import CalendarShiftBlock from './CalendarShiftBlock';
import { v4 as uuidv4 } from 'uuid';

import main from '../../../Assets/Styles/main.json';
import lineAwesomeConfig from '../../../Assets/Fontello/line-awesome-config.json';

const mainStyle = StyleSheet.create(main);
const Icon = createIconSetFromFontello(lineAwesomeConfig);

const CalendarRow = (props) => {

    const
        [shiftBlocks, setShiftBlocks] = useState([])
    ;

    const firstRender = useRef(true);

    const onFirstLoad = useCallback(() => {
        const init = async () => {
            let endTime = new Date(new Date(props.date).setHours(0, 0, 0, 0));
            endTime = new Date(endTime.setDate(endTime.getDate() + 1));
            endTime = new Date(endTime.getTime() - 1);

            let startOn = new Date(props.date);
            startOn = new Date(startOn.setHours(9, 0, 0, 0));

            //add items
            let shiftElements = [];
            let i = 0;
            let emptyEmployee = false;
            for (let shift of props.shifts) {
                //add shift
                shiftElements.push(
                    <CalendarShiftBlock
                        key={uuidv4()}
                        date={props.date}
                        shift={shift}
                        width={'100%'}//{(duration * ratio) + '%'}
                        reload={() => {
                            if (typeof props.reload === 'function') props.reload();
                        }}
                    />
                );

                //update currtime
                i++;

                emptyEmployee = shift.employee == undefined;
            };

            if (!emptyEmployee) {
                //add last item
                let postDuration = new Date(endTime).getTime() - new Date().getTime();
                if (postDuration > 0 && props.isLastRow) {
                    shiftElements.push(
                        <CalendarAddBlock
                            key={uuidv4()}
                            date={props.date}
                            open={props.open || false}
                            startOn={startOn}
                            employeeId={props?.employeeId}
                            departmentId={props?.departmentId}
                            width={'100%'}
                            reload={() => {
                                if (typeof props.reload === 'function') props.reload();
                            }}
                        />
                    );
                }
            }

            //set in state
            setShiftBlocks(shiftElements);
        }
        init();
    }, [props]);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            onFirstLoad();
        }
    }, [onFirstLoad]);

    //return
    return (
        <VStack width={'100%'}>
            {shiftBlocks}
        </VStack>
    );
};

export default CalendarRow;
